const map = {
	"./ARG.png": 4891,
	"./BRA.png": 7629,
	"./BRB.png": 8993,
	"./CHL.png": 2376,
	"./COL.png": 6993,
	"./CRI.png": 9095,
	"./DOM.png": 5979,
	"./ECU.png": 4854,
	"./LAC.png": 1971,
	"./MEX.png": 833,
	"./PAN.png": 9962,
	"./PER.png": 5850,
	"./TTO.png": 9264,
	"./URY.png": 5409
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 812;